"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNumber = _interopRequireDefault(require("../numbers/isNumber"));

var _text = require("../../constants/text");

var getNumericFontValue = function getNumericFontValue() {
  var fontSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _text.DEFAULT_FONT_SIZE;
  if ((0, _isNumber["default"])(fontSize)) return fontSize;
  var numericFontSize;
  var fontSizeWithoutPX = fontSize.replace('px', '');

  try {
    numericFontSize = parseInt(fontSizeWithoutPX, 10);

    if (!(0, _isNumber["default"])(numericFontSize)) {
      throw new Error("parseInt returns NaN on ".concat(numericFontSize));
    }
  } catch (e) {
    numericFontSize = _text.DEFAULT_FONT_SIZE;
  }

  return numericFontSize;
};

var _default = getNumericFontValue;
exports["default"] = _default;